export const centsToDollars = (cents: number | null | undefined): number | null =>
  cents == null ? null : cents / 100;

export const dollarsToCents = (dollars: number): number => dollars * 100;
